import { SelectChangeEvent } from '@mui/material';
import { useMemo } from 'react';
import { useLanguage } from '../../Hooks';

export const useLanguageSelector = () => {
  const { t, onLanguageChange, currentLanguage } = useLanguage();

  const changeLanguage = useMemo(
    () => (e: SelectChangeEvent<any>) => onLanguageChange(e.target.value),
    [],
  );

  return {
    t,
    onLanguageChange: changeLanguage,
    currentLanguage,
  };
};
